import { alpha, styled } from '@mui/material/styles';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export const Container = styled('div')(({ theme }) => ({
  // Scrollport only. Flex+center on this same node clips the start edge when
  // items overflow, and that overflow is not reachable by scrolling.
  flexShrink: 0,
  minWidth: 0,
  position: 'relative',
  zIndex: 1,
  backgroundColor: alpha(theme.palette.grey[500], 0.05),
  overflowX: 'auto',

  '& .MuiToggleButtonGroup-groupedSizeSmall': {
    height: 30,
  },

  '@media print': {
    display: 'none',
  },
}));

export const Inner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  width: 'max-content',
  minWidth: '100%',
  padding: theme.spacing(0.5),
}));

export const BtnGroup = styled(ToggleButtonGroup)({
  marginLeft: 8,
});

export const RowItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flex: '0 0 auto',
  margin: `0 ${theme.spacing(1)}`,

  '& .MuiTypography-root': {
    textAlign: 'right',
    flex: '0 0 auto',
    width: 'auto',
    whiteSpace: 'nowrap',
  },
}));
